import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, finalize } from 'rxjs';
import { AlertService } from '../components/alert/alert.service';
import { LoaderService } from '../services/loader.service';
import { CertAuthService } from '../services/cert-auth.service';

export function refNotificationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(CertAuthService);
  const alertSevice: AlertService = inject(AlertService);
  const loaderService: LoaderService = inject(LoaderService);
  const router: Router = inject(Router);

  loaderService.addRequest();

  return next(req).pipe(
    catchError((httpErrorResponse: HttpErrorResponse) => {
      if (httpErrorResponse.status === 0 || httpErrorResponse.status === 500) {
        alertSevice.open('error', `Neočekivana greška sustava`);
      } else {
        if (httpErrorResponse.status === 401) {
          authService.logout(true);
        }
        alertSevice.open('error', httpErrorResponse.error['Message']);
      }
      throw httpErrorResponse;
    }),
    finalize(() => loaderService.removeRequest())
  );
}
